
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("dPS3E"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("3xJ9n"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $cozmU.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $cozmU.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("bjVRl", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $d2a35dc366472da4$var$initialState = {
    portalContainerRef: null,
    autohighlightText: '',
    autohighlightContext: '',
    sessionId: '',
    autohighlightSelectionRect: {
        top: 0,
        left: 0,
        width: 0,
        height: 0
    },
    autohighlightHovered: false,
    showPopup: false,
    popupLoading: false,
    showSpotlight: false,
    existingMap: new Map(),
    lastAcronymReset: ()=>{},
    defineDefinitionOpen: false
};
const $d2a35dc366472da4$export$e324594224ef24da = {
    showAutohighlightPopup: ({ autohighlightText: autohighlightText, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, lastAcronymReset: lastAcronymReset, sessionId: sessionId })=>({ setState: setState })=>{
            setState({
                autohighlightText: autohighlightText,
                autohighlightContext: autohighlightContext,
                autohighlightSelectionRect: autohighlightSelectionRect,
                lastAcronymReset: lastAcronymReset,
                sessionId: sessionId,
                showPopup: true,
                popupLoading: true
            });
        },
    hideAutohighlightPopup: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                showPopup: false,
                popupLoading: false
            });
        },
    setDefineDefinitionOpen: ({ defineDefinitionOpen: defineDefinitionOpen })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                defineDefinitionOpen: defineDefinitionOpen
            });
        },
    setAutohighlightPopupLoaded: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                popupLoading: false
            });
        },
    setAutohighlightHovered: ({ autohighlightHovered: autohighlightHovered })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                autohighlightHovered: autohighlightHovered
            });
        },
    showAutohighlightSpotlight: ({ autohighlightSelectionRect: autohighlightSelectionRect })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                showSpotlight: true,
                autohighlightSelectionRect: autohighlightSelectionRect
            });
        },
    setPortalContainerRef: ({ portalContainerRef: portalContainerRef })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                portalContainerRef: portalContainerRef
            });
        }
};
const $d2a35dc366472da4$export$f24428a461500521 = (0, $8s9DV.createStore)({
    initialState: $d2a35dc366472da4$var$initialState,
    actions: $d2a35dc366472da4$export$e324594224ef24da,
    name: 'readingAidsStore'
});
const $d2a35dc366472da4$export$c6f45fcecbb3630d = (0, $kBr4q.createActionsHook)($d2a35dc366472da4$export$f24428a461500521);
const $d2a35dc366472da4$export$94639db5354ca53c = (0, $kBr4q.createStateHook)($d2a35dc366472da4$export$f24428a461500521);
module.exports["useReadingAidsActions"] = $d2a35dc366472da4$export$c6f45fcecbb3630d;
module.exports["useReadingAidsState"] = $d2a35dc366472da4$export$94639db5354ca53c;

});

parcelRegister("dPS3E", function(module, exports) {

let $a129f88ad1bb7bc0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a129f88ad1bb7bc0$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("3xJ9n", function(module, exports) {

let $29477a1431ec9937$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $29477a1431ec9937$var$load("kT6dz"),
    $29477a1431ec9937$var$load("3N1vv"),
    $29477a1431ec9937$var$load("cPAXo"),
    $29477a1431ec9937$var$load("44j0l"),
    $29477a1431ec9937$var$load("gbejv"),
    $29477a1431ec9937$var$load("GD9EA"),
    $29477a1431ec9937$var$load("7TnhR"),
    $29477a1431ec9937$var$load("hUbK8"),
    $29477a1431ec9937$var$load("eSqZD"),
    $29477a1431ec9937$var$load("2PFjC"),
    $29477a1431ec9937$var$load("gwGEC"),
    $29477a1431ec9937$var$load("l5nRU"),
    $29477a1431ec9937$var$load("fcAaN"),
    $29477a1431ec9937$var$load("2CrXe"),
    $29477a1431ec9937$var$load("beMmd"),
    $29477a1431ec9937$var$load("1rM9D"),
    $29477a1431ec9937$var$load("by6h6"),
    $29477a1431ec9937$var$load("j3345"),
    $29477a1431ec9937$var$load("2J2X1"),
    $29477a1431ec9937$var$load("do0Fh"),
    $29477a1431ec9937$var$load("1Gr4q"),
    $29477a1431ec9937$var$load("4RsKm"),
    $29477a1431ec9937$var$load("7oAXW"),
    $29477a1431ec9937$var$load("3RQq6"),
    $29477a1431ec9937$var$load("7DmOr"),
    $29477a1431ec9937$var$load("dxcsb"),
    $29477a1431ec9937$var$load("9ZFGK"),
    $29477a1431ec9937$var$load("2hLAI"),
    $29477a1431ec9937$var$load("dCilB"),
    $29477a1431ec9937$var$load("h1yOv"),
    $29477a1431ec9937$var$load("1T8H1"),
    $29477a1431ec9937$var$load("fyKFO"),
    $29477a1431ec9937$var$load("d9sg7"),
    $29477a1431ec9937$var$load("l0N35"),
    $29477a1431ec9937$var$load("cmmpX"),
    $29477a1431ec9937$var$load("fcsnw"),
    $29477a1431ec9937$var$load("z9yIf"),
    $29477a1431ec9937$var$load("694is"),
    $29477a1431ec9937$var$load("gfvIK"),
    $29477a1431ec9937$var$load("cyTuQ"),
    $29477a1431ec9937$var$load("jqoep"),
    $29477a1431ec9937$var$load("6wr18"),
    $29477a1431ec9937$var$load("59hV4"),
    $29477a1431ec9937$var$load("8zMmc"),
    $29477a1431ec9937$var$load("4x9Jx"),
    $29477a1431ec9937$var$load("a8glC"),
    $29477a1431ec9937$var$load("eCXJR"),
    $29477a1431ec9937$var$load("1VTX2"),
    $29477a1431ec9937$var$load("ffEVr"),
    $29477a1431ec9937$var$load("gzrfp"),
    $29477a1431ec9937$var$load("2EIkU"),
    $29477a1431ec9937$var$load("ddvkk"),
    $29477a1431ec9937$var$load("3upHR"),
    $29477a1431ec9937$var$load("iUXaE"),
    $29477a1431ec9937$var$load("lTkx9"),
    $29477a1431ec9937$var$load("Wowvf"),
    $29477a1431ec9937$var$load("eRhBr"),
    $29477a1431ec9937$var$load("hZ2FX"),
    $29477a1431ec9937$var$load("hhss7"),
    $29477a1431ec9937$var$load("7EorR"),
    $29477a1431ec9937$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.4769c86b.js.map
